/* eslint-env jquery */
const $ = jQuery.noConflict();

'use strict';
const EloaForm = {

	$domEloaDate: $('.js-contact__wrapper-input-date').find('input'),
	$domFileInput: $('.contact__wrapper-file-field'),
	$domSubmitSignature: $('#sig-submitBtn'),
	$domClearSignature: $('#sig-clearBtn'),
	$domSignatureSpan: $('.js-eloa__signature-hid-txt'),
	$domEloaSubmitWrap: $('.eloa__form').find('.holidays__wrapper-input-submit'),
	classEloaSubmitInvalid: 'submit-invalid',
	/*-------------------------------------------------------------------------------
		# Initialize
	-------------------------------------------------------------------------------*/
	init: function() {
		this.settingDateField();
		this.appendFields();
		this.customFile();
		/* this.signatureBehav(); */
		this.canvasSize();
		this.signatureValidation();
	},

	signatureValidation: function() {
		this.$domEloaSubmitWrap.addClass(this.classEloaSubmitInvalid);
		this.$domEloaSubmitWrap.append('<span class="eloa-submit-msg">Signature must be submitted.</span>');
	},

	canvasSize: function() {
		$('#sig-canvas').attr('width', 460);

		if(window.innerWidth < 1200) {
			$('#sig-canvas').attr('width', 362);
		}

		if(window.innerWidth < 992) {
			$('#sig-canvas').attr('width', 272);
		}
	},

	settingDateField: function() {
		if(EloaForm.$domEloaDate) {
			/* EloaForm.$domEloaDate.attr('disabled', 'disiabled'); */
			EloaForm.$domEloaDate.css({'background-color': '#ddd', 'pointer-events': 'none'});

			const date = new Date();
			let month = date.getMonth()+1;

			if(month < 10) {
				month = '0' + month;
			}else {
				month;
			}

			let day = date.getDate();
			if(day < 10) {
				day = '0' + day;
			}else {
				day;
			}

			EloaForm.$domEloaDate.val(date.getFullYear() + '-' + month + '-' + day);
		}
	},

	appendFields: function() {
		$('.js-eloa__signature-wrapper').insertAfter('.js-eloa-date-block');
		$('.js-eloa__text-block-wrapper').appendTo('.js-contact__wrapper-text-block');
	},

	customFile: function() {
		$('.wpcf7-file').on('change', function() {
			const value = $(this).val();
			const trimmedValue = value.substring(value.lastIndexOf('\\') + 1, value.length);
			$('.upload-file-txt').text(trimmedValue);
		});
	},

	/* signatureBehav: function() {
		EloaForm.$domSubmitSignature.on('click', function() {
			EloaForm.$domSignatureSpan.fadeOut(1000);
			$('#sig-image').fadeIn(1000);
		});

		EloaForm.$domClearSignature.on('click', function() {
			EloaForm.$domSignatureSpan.fadeIn(1000);
			$('#sig-image').hide();
		});
	}, */
};

export default EloaForm;
